/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @type {Array} The array filled with exceptions.
 */
export default [
	// Indefinite pronouns:
	"nejaký", "nejaká", "nejaké",
	// Numbers 0-10, 100, 1000:
	"jeden", "jedna", "jediný", "dva", "dvaja", "dve", "tri", "trojka", "traja", "štyri ", "štvoro", "štyria", "päť", "pät",
	"šesť", "sedem", "osem", "deväť", "desať", "sto", "tisíc",
	// Demonstrative pronouns:
	"ten", "tá", "to", "tento", "táto", "toto", "tamten", "tamtá", "tamto", "tí", "tie", "tieto", "toho", "tej", "tomu",
	"tú", "tom", "tým", "tou", "tých", "tými", "títo", "tamtí", "tamtie", "tamtoho", "tomuto", "tohto",
];
